<ngx-file-drop
  class="inline-mode"
  [ngClass]="{ 'file-drop-over': hasDropZoneOver }"
  (onFileOver)="hasDropZoneOver = true"
  (onFileLeave)="hasDropZoneOver = false"
  (onFileDrop)="dropped($event)"
  [multiple]="multiple"
  [disabled]="form.disabled"
  [accept]="accept"
>
  <!-- <ngx-file-drop class="inline-mode" [ngClass]="{'file-drop-over': hasDropZoneOver}" (onFileOver)="hasDropZoneOver = true" (onFileLeave)="hasDropZoneOver = false" (onFileDrop)="dropped($event)" [multiple]="multiple" [disabled]="form.disabled"> -->
  <ng-template
    ngx-file-drop-content-tmp
    let-openFileSelector="openFileSelector"
  >
    <button
      type="button"
      class="btn btn-sm btn-file text-gray-800"
      (click)="openFileSelector()"
      [disabled]="form.disabled"
    >
      {{ "COMPONENT.BROWSE_FILE" | translate }}
    </button>
    <div
      class="file-display cursor-pointer"
      [ngClass]="{ disabled: form.disabled }"
      (click)="openFileSelector()"
    >
      @if (displayFile) {
      <p class="mb-0 fs-form-control cursor-pointer">
        {{ displayFile }}
      </p>
      <a class="file-remove" (click)="removeFile($event)">
        <app-keenicon
          name="cross"
          class="fs-1 cursor-pointer pt-8"
          type="solid"
        ></app-keenicon>
      </a>
      } @else { @if (!form.disabled) {
      <p class="mb-0 text-muted fs-form-control cursor-pointer">
        {{ "APP.FILE_PLACEHOLDER" | translate }}
        <!-- <span class="text-danger">{{
            "APP.FILE_PLACEHOLDER_ADD_ON" | translate
          }}</span> -->
      </p>
      } }
    </div>
  </ng-template>
</ngx-file-drop>
